module.exports = __webpack_public_path__ + "static/media/table.f532326d.png";